import React from 'react';
import hydrate from '../lib/hydrate';
import AccountPagesNav from '../lib/components/LeftNav/AccountPagesNav';
import AuthenticationModal from '../lib/components/SignIn/AuthenticationModal';
import { AuthenticationModalContext, ModalContextProvider } from '../lib/context/ModalContext';
import { AuthenticationFormContextProvider } from '../lib/context/AuthenticationFormContext/AuthenticationFormContext';

/**
 * @name AccountPagesNavFrontend
 * @description Frontend wrapper component that provides authentication context and modal functionality for the account pages navigation
 * @private
 * @returns {JSX.Element} The AccountPagesNav component wrapped with authentication modal and context providers
 */
function AccountPagesNavFrontend() {
  return (
    <ModalContextProvider context={AuthenticationModalContext}>
      <AuthenticationFormContextProvider>
        <AuthenticationModal />
        <AccountPagesNav />
      </AuthenticationFormContextProvider>
    </ModalContextProvider>
  );
}

hydrate({
  component: AccountPagesNavFrontend,
  frontend: 'AccountPagesNavFrontend',
});
